/**
 * Created by devpatel on 1/21/14.
 */
'use strict';

var $ = require('dibs-jquery-shim');
var _ = require('underscore');
var PageLoader;

/**
 * SETUP
 * You can either extend your view's prototype like:
 * _.extend(MyView.prototype, dibs.pageLoader)
 *
 * OR you can use .marinate as shown here
 * dibs.MyView = Backbone.View.extend({
 *  pageLoaderBlock : '#block-this',
 *  initialize : function () {
 *      this.loadingStart();
 *  }
 *  render: {
 *      this.loadingStop();
 *  }
 * }).marinate(dibs.pageLoader);
 *
 * USE
 * Set the element which you want to block as pageLoaderBlock as
 * shown in example above. Than you can use functions this.loadingStart()
 * and this.loadingStop() to show and hide the loader.
 *
 * OPTIONS
 * Both functions take selector string as first argument and
 * config object as second argument. Config is passed to fadeIn(config)
 * and fadeOut effect of jQuery for extensive control as shown below.
 *      this.loadingStart('#block-this', {
 *          duration: 1000,
 *          easing: 'linear',
 *          complete : function () {}
 *      });
 *
 * @type {{loaderSelector: string, loadingStart: Function, loadingStop: Function, showLoader: Function, setupOptions: Function}}
 */
PageLoader = {
    // Actual class of the loading div
    loaderSelector: '.page-overlay-spinner',
    /**
     * Shows the loader over passed selector
     * @param blockUI
     * @param config
     *      - options : optional, options to be applied to effectOptions
     *      - styles : optional styles to be applied to .page-overlay-spinner div
     * @returns {pageLoader}
     */
    loadingStart: function(blockUI, config) {
        if (config && config.options) {
            this.setupOptions(config.options);
        }

        blockUI = blockUI || this.pageLoaderBlock;
        if (blockUI) {
            this.showLoader($(blockUI), config);
        } else {
            this.showLoader(this.$el, config);
        }
        return this;
    },
    /**
     * Hides the loader div from passed selector
     * @param blockUI
     * @param config
     * @returns {pageLoader}
     */
    loadingStop: function(blockUI, config) {
        var blockEl;
        var $blockUI;
        this.setupOptions(config);

        blockEl = blockUI || this.pageLoaderBlock;
        $blockUI = !_.isEmpty($(blockEl)) ? $(blockEl) : this.$el;

        $blockUI
            .find(this.loaderSelector)
            .parent()
            .stop()
            .fadeOut(this.effectOptions)
            .attr('data-tn', 'spinner-hidden');

        return this;
    },
    /**
     * Checks if loader exists in passed selector and shows it or
     * creates a new loader div and prepends to the selector
     * @param selector
     * @param config
     */
    showLoader: function(selector, config) {
        var $loader = selector.find($(this.loaderSelector));
        var loaderClass = this.loaderSelector.replace(/./, '');
        var newLoader;

        if ($loader.length > 0) {
            $loader
                .parent()
                .fadeIn(this.effectOptions)
                .attr('data-tn', 'spinner-active');
            return;
        }
        newLoader = $('<div></div>', { class: 'page-overlay-spinner-wrapper' }).hide();

        newLoader.html($('<div></div>', { class: loaderClass }));

        if (config && config.html) {
            newLoader.append($('<div class="alert-wrapper"></div>').html(config.html));
        }

        if (config && config.styles) {
            newLoader.css(config.styles);
        }

        selector.prepend(newLoader);
        newLoader.fadeIn(this.effectOptions);
    },
    /**
     * Extends default options for fadeIn and fadeOut
     * @param config
     */
    setupOptions: function(config) {
        this.effectOptions = _.extend(
            {
                duration: 0,
                easing: 'swing',
                queue: true,
            },
            config
        );
    },
};

module.exports = PageLoader;
